module.exports = __webpack_public_path__ + "static/media/PLAYER5-TAG.1ed4bbe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/PLAYER5-TAG.png
// module id = 270
// module chunks = 0